import React from "react";
import { Icons } from "../Icons";
import Logo from "./Logo";
import { CATALOG } from "../../data/catalog";

const Footer = ({ go }) => {
  const catKeys = Object.keys(CATALOG);

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-grid">
          <div>
            <Logo onClick={() => go("home")} dark />
            <p className="footer-brand-desc">
              Premium wholesale electronics supplier . Trusted B2B
              partner for your businesses across multiple countries.
            </p>

          </div>
          <div>
            <div className="footer-col-title">Company</div>
            <div className="footer-links">
              {["home", "about", "products", "faqs", "contact"].map((l) => (
                <span key={l} className="footer-link" onClick={() => go(l)}>
                  {l === "faqs" ? "FAQs" : l[0].toUpperCase() + l.slice(1)}
                </span>
              ))}
            </div>
          </div>
          <div>
            <div className="footer-col-title">Categories</div>
            <div className="footer-links">
              {catKeys.map((k) => (
                <span
                  key={k}
                  className="footer-link"
                  onClick={() => go("products")}
                >
                  {CATALOG[k].name}
                </span>
              ))}
            </div>
          </div>
          <div>
            <div className="footer-col-title">Contact Us</div>
            <div className="footer-links">
              <span className="footer-link" style={{ display: 'flex', gap: 8, alignItems: 'flex-start', cursor: 'default' }}>
                <Icons.MapPin size={16} style={{ marginTop: 2, flexShrink: 0 }} />
                <span style={{ lineHeight: 1.4 }}>Academy House, 11 Dunraven Place,<br/>Bridgend, Mid Glamorgan,<br/>United Kingdom, CF31 1JF</span>
              </span>
              <a href="mailto:contact@newcoverltd.co.uk" className="footer-link" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <Icons.Mail size={16} />
                <span>contact@newcoverltd.co.uk</span>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            © 2026 <em>NewCover Ltd</em>. All rights reserved.
          </p>
          <span>Wholesale Electronics · Global B2B Supply</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
